import { middlewareController } from 'shared/api/middlewareController'

export const officeApi = middlewareController.create.axiosInstance({
  baseURL: process.env.REACT_APP_CLUSTER_OFFICE_DOCUMENT_SERVER_ENDPOINT
})
